<template>
  <div class="container">
    <Nav @handlePath="getPath"></Nav>
    <div class="index_hearderImg">
      <img :src="AboutImg" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-icon-arrow-right"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>关于我们</el-breadcrumb-item>
          <el-breadcrumb-item>{{ AboutName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>

    <div class="community index_center">
      <div class="community_right">
        <router-view></router-view>
      </div>
      <SubmitFrom></SubmitFrom>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import AboutUsBar from "./components/AboutUsBar";
import SubmitFrom from "./components/SubmitFrom";

export default {
  components: {
    Nav,
    AboutUsBar,
    Foot,
    SubmitFrom,
  },
  name: "Community",
  data() {
    return {
      showType: "6",
      communityList: [],
      pageNumber: 1,
      pageSize: 12,
      totalCount: 0,
      AboutPath: "",
      AboutList: [],
      dropdownList: [
        {
          name: "公司简介",
          path: "/Community/CompanyProfile",
          imgSrc: require("../assets/qingye/Aboutus.png"),
        },
        {
          name: "荣誉资质",
          path: "/Community/HonoraryCertificate",
          imgSrc: require("../assets/qingye/1102.png"),
        },
        {
          name: "下载中心",
          path: "/Community/DataDownload",
          imgSrc: require("../assets/qingye/1102.png"),
        },
        {
          name: "联系我们",
          path: "/Community/ContactUs",
          // imgSrc: 'http://127.0.0.1:8080/static/img/Contactus.52d8304.png'
          imgSrc: require("../assets/qingye/Contactus.png"),
        },
      ],
      AboutName: "公司简介",
      // AboutImg:'http://127.0.0.1:8080/static/img/Aboutus.4ac8f96.png'
      AboutImg: require("../assets/qingye/Aboutus.png"),
    };
  },
  created() {
    this.dropdownList.forEach((item) => {
      if (item.path == this.$route.path) {
        this.AboutName = item.name;
        this.AboutImg = item.imgSrc;
      }
    });
  },
  methods: {
    getAboutBar(path, list) {
      // this.AboutPath = path
      // this.AboutList = list
      // this.AboutList.forEach(item => {
      //   console.log(item)
      //   if (path == item.name) {
      //     this.AboutName = item.AboutUsBarItem
      //   }
      // })
    },
    // 获取子路由传来的数据
    getPath(path, list) {
      this.AboutPath = path;
      this.AboutList = list;
      this.AboutList.forEach((item) => {
        if (path == item.path) {
          console.log(item);
          this.AboutName = item.name;
          this.AboutImg = item.imgSrc;
        }
      });
    },
  },
  mounted() {},
};
</script>
<style scoped>
.index_center {
  margin: 0 auto;
  /*width: 1200px;*/
}

.breadcrumb_center {
  width: 100%;
  background-color: #f6f7f8;
  display: flex;
  justify-content: space-around;
  height: 50px;
}
.el-icon-arrow-right {
  display: flex;
  align-items: center;
  width: 1200px;

  color: #666666;
}
.el-icon-arrow-right img {
  padding: 0 10px 0px 0;
}
.index_hearderImg {
  /*display: flex;*/
  /*justify-content: center;*/
  min-width: 1200px;
  height: 258px;
}
.index_hearderImg img {
  width: 100%;
  height: 100%;
}
div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

/*-----------------------*/
/*.community {*/
/*  !*width: 994px;*!*/
/*  width: 1360px;*/
/*  margin: 0 auto;*/
/*  margin-top: 70px;*/
/*  justify-content: space-between;*/
/*}*/

.community {
  /*margin-top: 70px;*/
  padding-top: 70px;
  display: flex;
  justify-content: center;
  /*max-width: 1920px;*/
  min-width: 1200px;
}
.community_left {
  width: 150px;
  padding-top: 250px;
}
.community_right {
  /*padding-left: 20px;*/
  display: contents;
}

.community_tab {
  width: 100%;
}

.community >>> .el-tabs__nav {
  display: flex;
  width: 994px;
  flex-direction: row;
  justify-content: space-between;
}

.community >>> .el-tabs__header {
  margin: 0px !important;
}

.community >>> .el-tabs__nav-wrap::after {
  height: 0px;
}

.community >>> .el-tabs__item {
  padding: 0 !important;
  background-color: rgb(27, 99, 167, 0.12);
  text-align: center;
  margin-left: 1px;
  flex: 1;
  color: #1b63a7;
}

.community >>> .el-tabs__item:nth-child(2) {
  margin-left: 0px;
}

.community >>> .el-tabs__item.is-active {
  color: white;
  background: #1b63a7;
}

.community >>> .el-tabs__item:hover {
  color: none;
}

.community >>> .el-tabs__active-bar {
  height: 0px;
}

.community .community_content {
  margin-top: 20px;
  flex-wrap: wrap;
}

.community .community_content .no_data {
  text-align: center;
  width: 100%;
  padding: 100px 0px;
}

.community .community_li {
  /*height: 234px;*/
  width: 230px;
  margin-bottom: 24px;
  margin-right: 24.4px;
}

.community_li:nth-child(4n) {
  margin-right: 0px;
}

.community_li .img {
  width: 100%;
  height: 156px;
}

.community_li .title {
  font-size: 14px;
  margin-top: 20px;
}

.community_li .time {
  font-size: 12px;
  color: #666666;
  margin-top: 10px;
}

.community .paging_block {
  width: 100%;
  text-align: right;
  margin-top: 60px;
  margin-bottom: 100px;
}

.paging {
  margin-top: 20px;
  width: 100%;
  text-align: right;
}

.paging >>> .el-pagination {
  padding: 0px;
}

.paging >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1b63a7;
  border: 1px solid #1b63a7;
}

.paging >>> .el-pagination.is-background .btn-next,
.paging >>> .el-pagination.is-background .btn-prev,
.paging >>> .el-pagination.is-background .el-pager li {
  background-color: white;
  border: 1px solid #e8e8e8;
}

.paging >>> .el-pager li {
  line-height: 27px;
}

.community_content {
  font-weight: 400;
  font-size: 24px;
}
.community_content_text {
  display: flex;
}
.community_content_text div {
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Community.vue